import { isMacroCategory, getCategoryByID, getMacroOfCategoryID } from '@sbt-web/category-utils';
import { categoryMap } from './config.js';

const market = ['elettronica', 'casa-e-persona', 'sport-hobby', 'vari'];
const getFormattedForCategorySelectorDialog = (category) => {
    if (category === undefined || category === 'usato') {
        return categoryMap.motori;
    }
    else if (market.includes(category)) {
        return categoryMap.market;
    }
    else {
        return category;
    }
};
const getMacroCategory = (categoryId) => {
    if (!isMacroCategory(getCategoryByID(categoryId))) {
        const category = getMacroOfCategoryID(categoryId).friendly;
        return getFormattedForCategorySelectorDialog(category);
    }
    else {
        const macroCategory = getCategoryByID(categoryId).friendly;
        return getFormattedForCategorySelectorDialog(macroCategory);
    }
};

export { getMacroCategory };
//# sourceMappingURL=getPageMacroCategory.js.map
